var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5627 3.3397C20.4189 3.24181 20.2521 3.18305 20.0787 3.1692C19.9053 3.15535 19.7313 3.18688 19.5737 3.2607L2.57374 11.2607C2.39996 11.3426 2.25345 11.4728 2.15173 11.6357C2.05 11.7987 1.99736 11.9875 2.0001 12.1796C2.00284 12.3717 2.06085 12.5589 2.16719 12.7189C2.27353 12.8788 2.4237 13.0048 2.59974 13.0817L7.99974 15.4447V22.1667L13.8357 17.9987L18.5997 20.0827C18.7468 20.1471 18.9072 20.1752 19.0675 20.1645C19.2277 20.1538 19.3829 20.1047 19.5202 20.0213C19.6574 19.9379 19.7725 19.8228 19.8558 19.6855C19.9391 19.5482 19.9881 19.3929 19.9987 19.2327L20.9987 4.2327C21.0097 4.05883 20.9753 3.88509 20.8988 3.72854C20.8224 3.57198 20.7066 3.43799 20.5627 3.3397ZM18.0967 17.6797L12.8277 15.3737L15.9997 9.1667L8.35074 13.4167L5.41874 12.1337L18.8897 5.7937L18.0967 17.6797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPaperPlane);
export default __webpack_public_path__ + "static/media/bx-paper-plane.47b4997c2972c61a4753e6b04117e031.svg";
export { ForwardRef as ReactComponent };